import { wrapRootElement as wrap } from './src/root-wrapper';

export const wrapRootElement = wrap;
